module.exports = __webpack_public_path__ + "static/media/profile_icon.d9ea6218.png";